// index.js
import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";

// Render de la app
const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(<App />);

// Registro del Service Worker
if ("serviceWorker" in navigator) {
  window.addEventListener("load", () => {
    navigator.serviceWorker
      .register("/sw.js") // 👈 tu archivo modificado con importScripts
      .then((registration) => {
        console.log("✅ Service Worker registrado con éxito:", registration);
      })
      .catch((error) => {
        console.error("❌ Error al registrar el Service Worker:", error);
      });
  });
}

if ("serviceWorker" in navigator) {
  window.addEventListener("load", () => {
    navigator.serviceWorker
      .register("/sw.js")
      .then((registration) => {
        console.log("Service Worker registrado con éxito:", registration);

        // Escuchar cuando haya una nueva versión del SW
        registration.onupdatefound = () => {
          const newWorker = registration.installing;
          newWorker.onstatechange = () => {
            if (newWorker.state === "installed") {
              if (navigator.serviceWorker.controller) {
                // ✅ Ya hay un SW activo -> significa que hay una nueva versión
                const updateBanner = document.createElement("div");
                updateBanner.innerText =
                  "⚡ Nueva versión disponible. Haz clic para actualizar.";
                updateBanner.style.position = "fixed";
                updateBanner.style.bottom = "20px";
                updateBanner.style.left = "50%";
                updateBanner.style.transform = "translateX(-50%)";
                updateBanner.style.background = "#222";
                updateBanner.style.color = "#fff";
                updateBanner.style.padding = "10px 20px";
                updateBanner.style.borderRadius = "8px";
                updateBanner.style.cursor = "pointer";
                updateBanner.style.zIndex = "9999";

                updateBanner.onclick = () => {
                  newWorker.postMessage({ type: "SKIP_WAITING" });
                  window.location.reload();
                };

                document.body.appendChild(updateBanner);
              } else {
                console.log("App lista para usarse offline 🚀");
              }
            }
          };
        };
      })
      .catch((error) => {
        console.error("Error al registrar el Service Worker:", error);
      });

    // 🔄 Escuchar cuando el SW mande la señal de actualización
    navigator.serviceWorker.addEventListener("controllerchange", () => {
      window.location.reload();
    });
  });
}
